import { render, staticRenderFns } from "./InvoicesPackTable.vue?vue&type=template&id=58b0212e"
import script from "./InvoicesPackTable.vue?vue&type=script&lang=js"
export * from "./InvoicesPackTable.vue?vue&type=script&lang=js"
import style0 from "./InvoicesPackTable.vue?vue&type=style&index=0&id=58b0212e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports